export class LivewirePagination {
  constructor() {
    window.addEventListener('pageChanged', () => {
      let topComponent = document.querySelector('.s-dynamic-map__listing');

      if (topComponent) {
        topComponent.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    })
  }
}
